import React, { useState, useRef, useEffect } from 'react';
import { cloneDeep } from 'lodash';

import { Search } from '../../ui/search';

import './styles/account-user-dropdown.scss';

const AccountUserDropdown = ({
  results,
  inputState,
  setInputState,
  setOpenDropdown,
  openDropdown,
}) => {
  const open = openDropdown === 'account-user';

  const [didMount, setDidMount] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(results);

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    setSearchResults(results);
  }, [results]);

  useEffect(() => {
    if (didMount) {
      setOpenDropdown('account-user');
    }
  }, [searchTerm]);

  function onSearch(searchTerm) {
    setSearchTerm(searchTerm);
    if (searchTerm) {
      setSearchResults(
        results.filter(result => result.email.toLowerCase().includes(searchTerm.toLowerCase())),
      );
    } else {
      setSearchResults(results);
    }
  }

  function selectOption(e, index) {
    e.stopPropagation();
    setOpenDropdown(null);
    const newInputState = cloneDeep(inputState);
    setInputState({
      ...newInputState,
      first_name: searchResults[index].first_name,
      last_name: searchResults[index].last_name,
      email: searchResults[index].email,
      uid: searchResults[index].uid,
    });
  }

  const menu =
    open && searchResults && searchResults.length ? (
      <div className="dropdown-menu">
        <div className="results">
          {searchResults.map((result, index) => (
            <li className="dropdown-item" key={index} onClick={e => selectOption(e, index)}>
              {result.email}
            </li>
          ))}
        </div>
      </div>
    ) : null;

  return (
    <div
      className="account-user-dropdown"
      onClick={e => {
        setOpenDropdown('account-user');
        e.stopPropagation();
      }}
    >
      <Search
        debounce={true}
        onSearch={onSearch}
        placeholder="Start typing to search for email..."
      />
      {menu}
    </div>
  );
};

export default AccountUserDropdown;
